import { useSelector } from "react-redux";
import useAppNavigation from "system/hooks/use-app-navigation";
import IRootState from "system/types/store/IRootState";
import { Avatar } from "@mui/material";
import { useEffect, useState } from "react";
import { ValueResponse } from "system/types/wireTypes";
import { useApi } from "system/hooks";

const PageTitle = () => {
  const navigate = useAppNavigation();
  const api = useApi();
  const { pageTitle, subTitle, navigateOnTitleClick, navigateOnSubTitleClick, icons, subject } = useSelector(
    (state: IRootState) => state.main
  );
  const { tenants, currentTenantId } = useSelector((state: IRootState) => state.config);
  const [iconUrl, setIconUrl] = useState<string | null>(null);

  // Memoize the icon URL calculation to prevent unnecessary re-calculations
  useEffect(() => {
    if (!subject) {
      setIconUrl(null);
      return;
    }
    const fetchIcon = async () => {
      const matchingIcon = icons?.find((icon) => icon.subject.toLowerCase() === subject.toLowerCase());
      if (matchingIcon) {
        setIconUrl(matchingIcon.iconUrl || null);
        return;
      }

      if (!tenants || !currentTenantId) {
        setIconUrl(null);
        return;
      }
      try {
        const currentTenant = tenants.find((tenant) => tenant.siteId === currentTenantId);
        const response: ValueResponse<string> = await api.icons.getIconBySubject(subject, currentTenant?.shortName || "");
        setIconUrl(response.value || null);
      } catch (error) {
        setIconUrl(null);
      }
    };

    fetchIcon();
  }, [api.icons, currentTenantId, icons, subject, tenants]);

  if (!pageTitle) {
    return <></>;
  }
  return (
    <div className="dialog-title-wrapper">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "5px",
        }}
      >
        {subject && (
          <Avatar
            src={iconUrl || "/img/DefaultPackage.png"}
            alt={iconUrl ? `${pageTitle} icon` : "Package Icon"}
            sx={{
              width: 24,
              height: 24,
              objectFit: "contain",
              borderRadius: "0%",
            }}
          />
        )}
        <h3
          onClick={
            navigateOnTitleClick
              ? () => {
                  navigate(navigateOnTitleClick);
                }
              : undefined
          }
          style={{ cursor: navigateOnTitleClick ? "pointer" : "" }}
        >
          {pageTitle}
        </h3>
      </div>
      <h6
        onClick={
          navigateOnSubTitleClick
            ? () => {
                navigate(navigateOnSubTitleClick);
              }
            : undefined
        }
        style={{ cursor: navigateOnSubTitleClick ? "pointer" : "" }}
      >
        {subTitle}
      </h6>
    </div>
  );
};

export default PageTitle;
